import React from 'react'
import { t } from 'ttag'

import { CreateTemplate } from './common/CreateTemplate/CreateTemplate'
import { SaveTemplate } from './common/SaveTemplate/SaveTemplate'

import { TEMPLATE_NAME_FIELD } from './common/CreateTemplate/model'

const CREATE_TEMPLATE = 'createTemplate'
const SAVE_TEMPLATE = 'saveTemplate'

export const STEP_NAMES = {
  SAVE_TEMPLATE,
  CREATE_TEMPLATE,
}

export const getCreateDefaultValues = () => ({
  [TEMPLATE_NAME_FIELD]: '',
})

export const getActiveStep = state => {
  const { create, step } = state

  const steps = {
    [STEP_NAMES.CREATE_TEMPLATE]: <CreateTemplate {...{ ...create }} />,
    [STEP_NAMES.SAVE_TEMPLATE]: <SaveTemplate />,
  }

  return steps[step]
}

export const getSteps = () => [
  { id: STEP_NAMES.SAVE_TEMPLATE },
  { id: STEP_NAMES.CREATE_TEMPLATE },
]

export const getModalTitle = state => {
  const { step } = state

  const titles = {
    [STEP_NAMES.CREATE_TEMPLATE]: t`Create template`,
    [STEP_NAMES.SAVE_TEMPLATE]: t`Save this new job as a template?`,
  }

  return titles[step]
}

export const getCancelButtonLabel = state => {
  const { step } = state

  const labels = {
    [STEP_NAMES.CREATE_TEMPLATE]: t`Cancel`,
    [STEP_NAMES.SAVE_TEMPLATE]: t`No, thanks`,
  }

  return labels[step]
}

export const getConfirmButtonLabel = state => {
  const { step } = state

  const labels = {
    [STEP_NAMES.CREATE_TEMPLATE]: t`Save new template`,
    [STEP_NAMES.SAVE_TEMPLATE]: t`Yes, save new template`,
  }

  return labels[step]
}
